import React from 'react';
export const ExtendedTestimonialsSection = () => {
  const testimonials = [{
    initials: 'CM',
    bg: 'bg-biosync',
    name: 'Claudia M.',
    loc: '📍 Buenos Aires · Madre',
    quote: 'Compré un sábado a la noche. El domingo mi hijo ya estaba leyendo el primer módulo solo. En dos semanas empezó a usar las técnicas de respiración sin que yo se lo recordara. BIO-SYNC hace lo que promete.'
  }, {
    initials: 'RS',
    bg: 'bg-biosync-azul',
    name: 'Roberto S.',
    loc: '📍 Ciudad de México · Padre',
    quote: 'Mi hija de 14 tenía crisis de ansiedad antes de los exámenes. Después del Módulo 1 me dijo que usó el protocolo de respiración en el baño del colegio antes de entrar. Sacó la mejor nota del año.'
  }, {
    initials: 'ML',
    bg: 'bg-biosync-lavanda',
    name: 'María L.',
    loc: '📍 Bogotá · Madre',
    quote: 'El módulo de autoestima fue el más importante para nosotras. Mi hija dejó de revisar los likes cada 5 minutos. Eso solo ya justificó cada peso que pagué.'
  }, {
    initials: 'JP',
    bg: 'bg-biosync-rosa',
    name: 'Jorge P.',
    loc: '📍 Lima · Padre',
    quote: 'El Bono de la Guía para Padres me cambió la forma de hablar con mi hijo. Dejé de dar consejos y empecé a escuchar. La conexión que recuperamos en un mes no la había tenido en dos años.'
  }, {
    initials: 'LR',
    bg: 'bg-biosync-durazno',
    name: 'Laura R.',
    loc: '📍 Montevideo · Madre',
    quote: 'Mi hijo de 17 años que no hablaba de nada empezó a mostrarme cosas del módulo de conexión. Él me explicó qué era la CNV. No lo podía creer.'
  }, {
    initials: 'VT',
    bg: 'bg-biosync-menta',
    name: 'Valeria T.',
    loc: '📍 Caracas · Madre',
    quote: 'El Kit de Emergencia vale por todo el sistema. Mi hija lo tiene en el teléfono. Cuando viene una crisis abre la ficha y sigue los pasos. Sin que yo intervenga.'
  }];
  const featuredTestimonial = {
    initials: 'AR',
    bg: 'bg-biosync',
    name: 'Ana R.',
    loc: '📍 Santiago · Madre',
    quote: 'Tres meses después de BIO-SYNC mi hija me pidió hablar sobre una relación tóxica que tenía. Ella sola identificó que le hacía daño. Eso no tiene precio.'
  };
  return <section className="bg-biosync-bgAlt py-10 px-5 sm:px-10" data-id="element-64">
      <div className="max-w-[1100px] mx-auto" data-id="element-65">
        <h2 className="text-3xl sm:text-4xl font-bold text-center text-biosync-text mb-12" data-id="element-66">
          "Lo que dicen las familias
          <br className="hidden sm:block" data-id="element-67" /> que ya usan BIO-SYNC:"
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6" data-id="element-68">
          {testimonials.map((t, i) => <div key={i} className="bg-biosync-bgTest border border-biosync/20 rounded-2xl p-6 shadow-sm flex flex-col" data-id="element-69">
              <div className="flex items-center gap-4 mb-4" data-id="element-70">
                <div className={`w-12 h-12 rounded-full ${t.bg} ${t.bg === 'bg-biosync' ? 'text-white' : 'text-biosync-text'} flex items-center justify-center font-bold text-lg shrink-0`} data-id="element-71">
                  {t.initials}
                </div>
                <div data-id="element-72">
                  <div className="text-yellow-400 text-sm mb-1" data-id="element-73">⭐⭐⭐⭐⭐</div>
                  <p className="font-bold text-biosync-text" data-id="element-74">{t.name}</p>
                  <p className="text-biosync-textSec text-xs" data-id="element-75">{t.loc}</p>
                </div>
              </div>
              <p className="text-biosync-text italic text-sm sm:text-base leading-relaxed" data-id="element-76">
                "{t.quote}"
              </p>
            </div>)}
        </div>

        <div className="max-w-2xl mx-auto" data-id="element-77">
          <div className="bg-biosync-bgTest border border-biosync/20 rounded-2xl p-6 shadow-sm flex flex-col" data-id="element-78">
            <div className="flex items-center gap-4 mb-4" data-id="element-79">
              <div className={`w-12 h-12 rounded-full ${featuredTestimonial.bg} text-white flex items-center justify-center font-bold text-lg shrink-0`} data-id="element-80">
                {featuredTestimonial.initials}
              </div>
              <div data-id="element-81">
                <div className="text-yellow-400 text-sm mb-1" data-id="element-82">⭐⭐⭐⭐⭐</div>
                <p className="font-bold text-biosync-text" data-id="element-83">
                  {featuredTestimonial.name}
                </p>
                <p className="text-biosync-textSec text-xs" data-id="element-84">
                  {featuredTestimonial.loc}
                </p>
              </div>
            </div>
            <p className="text-biosync-text italic text-sm sm:text-base leading-relaxed" data-id="element-85">
              "{featuredTestimonial.quote}"
            </p>
          </div>
        </div>
      </div>
    </section>;
};